/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MWLItem from './mwl-item';
import MWLItemDetail from './mwl-item-detail';
import MWLItemUpdate from './mwl-item-update';
import MWLItemDeleteDialog from './mwl-item-delete-dialog';

const MWLItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MWLItem />} />
    <Route path="new" element={<MWLItemUpdate />} />
    <Route path=":id">
      <Route index element={<MWLItemDetail />} />
      <Route path="edit" element={<MWLItemUpdate />} />
      <Route path="delete" element={<MWLItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MWLItemRoutes;
